import React, { useEffect, useState } from 'react';
import { 
    Box, 
    Typography, 
    Card, 
    CardContent, 
    Button, 
    Grid,
    IconButton,
    Pagination,
    CircularProgress,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Contest } from '../../../api/contest';

const MyContestList = () => {
    const [contests, setContests] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(4);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // useEffect(() => {
    //   if(isMobile){
    //     setPageSize(1)
    //   }else{
    //     setPageSize(4)
    //   }
    // }, [isMobile]);

    useEffect(() => {
        const newSize = isMobile ? 1 : 4;
        if (pageSize !== newSize) {
            setPageSize(newSize);
            return; // Tránh gọi fetch khi pageSize vừa thay đổi
        }
        const fetchContest = async () => {
          setLoading(true); // Bắt đầu tải dữ liệu
          try {
            
            const response = await Contest.getMyContests(currentPage, pageSize);
            setContests(response?.data || []);
            setPagination({
                currentPage: parseInt(response?.current_page || '1'),
                totalPages: parseInt(response?.total_page || '1'),
                totalItems: parseInt(response?.total || '0'),
            });
          } catch (error) {
            console.error("Error fetching badges:", error);
            setContests([]);
          } finally {
            setLoading(false);
          }
        };
    
        fetchContest();
    }, [currentPage, pageSize, isMobile]);

    const handlePageChange = async (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant="h6" color="primary" sx={{ mb: 3 }}>
                My Contests
            </Typography>

            <Box sx={{ position: 'relative', mb: 3 }}>
                {pagination.currentPage > 1 && (
                    <IconButton 
                        onClick={(e) => handlePageChange(e, pagination.currentPage - 1)}
                        sx={{
                            position: 'absolute',
                            left: -20,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            bgcolor: 'background.paper',
                            boxShadow: 2,
                            '&:hover': { bgcolor: 'background.paper' },
                            zIndex: 1
                        }}
                    >
                        <ChevronLeft />
                    </IconButton>
                )}

                {pagination.currentPage < pagination.totalPages && (
                    <IconButton 
                        onClick={(e) => handlePageChange(e, pagination.currentPage + 1)}
                        sx={{
                            position: 'absolute',
                            right: -20,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            bgcolor: 'background.paper',
                            boxShadow: 2,
                            '&:hover': { bgcolor: 'background.paper' },
                            zIndex: 1
                        }}
                    >
                        <ChevronRight />
                    </IconButton>
                )}

                <Grid container spacing={3}>
                    {contests && contests.length > 0 ? (
                        contests.map((contest) => (
                            <Grid item xs={12} sm={6} md={3} key={contest.id}>
                                <Card sx={{ 
                                    height: '100%',
                                    width: '100%',
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    bgcolor: '#F8F9FA',
                                    boxShadow: 'none',
                                    borderRadius: '8px'
                                }}>
                                    <Box sx={{
                                        position: 'relative',
                                        width: '100%',
                                        height: '180px',
                                        borderRadius: '8px',
                                        overflow: 'hidden'
                                    }}>
                                        <img 
                                            src={process.env.URL_CONTEST + '/storage/'+ contest.thumbnail} 
                                            alt={contest.title}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => window.open(process.env.URL_CONTEST + '/events/'+ contest.slug, '_blank')}
                                        />
                                    </Box>
                                    <CardContent sx={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        flexDirection: 'column',
                                        p: 3,
                                        position: 'relative',
                                        zIndex: 1
                                    }}>
                                        <Typography 
                                            variant="h6" 
                                            sx={{ 
                                                mb: 2,
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                lineHeight: '24px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                height: '48px',
                                                bgcolor: 'transparent'
                                            }}
                                        >
                                            {contest.title}
                                        </Typography>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography 
                                                variant="body2" 
                                                sx={{ 
                                                    mb: 1,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical'
                                                }}
                                            >
                                                {contest.description.replace(/<[^>]*>/g, '')}
                                            </Typography>
                                        </Box>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={() => window.open(process.env.URL_CONTEST + '/events/'+ contest.slug + '?required=login', '_blank')}
                                            sx={{
                                                mt: 2,
                                                bgcolor: '#FF4D00',
                                                '&:hover': {
                                                    bgcolor: '#cc3d00'
                                                },
                                                textTransform: 'none',
                                                borderRadius: '4px',
                                                height: '40px'
                                            }}
                                        >
                                            Go
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Grid item xs={12}>
                            <Typography variant="body1" textAlign="center">
                                No data available
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Box>

            {pagination.totalPages > 1 && (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    mt: 2,
                    '& .MuiPagination-ul': {
                        gap: '8px'
                    }
                }}>
                    <Pagination
                        count={pagination.totalPages}
                        page={pagination.currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        size="large"
                        showFirstButton
                        showLastButton
                    />
                </Box>
            )}
        </Box>
    );
};

export default MyContestList; 